// =============================================================================================
// ==== Utworzony w Krok 4A >>>>

import React from 'react';
import { Box, Typography } from '@mui/material';
import { DatePicker, TimePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { FormSection } from '../../../types/forms';

interface DatePickerFieldProps {
  section: FormSection;
  value?: string;
  onChange: (value: string | null) => void;
  error?: string;
}

export const DatePickerField: React.FC<DatePickerFieldProps> = ({
  section,
  value,
  onChange,
  error
}) => {
  // Parse config options
  const isDatePartOn = section.config?.isDatePartOn !== false; // default true
  //const isTimePartOn = section.config?.isTimePartOn === true; // default false
  const isTimePartOn = section.config?.isTimePartOn === true 
  
  // ==== TEMP DEBUG
  console.log('DatePickerField config:', section.config);
  console.log('isDatePartOn:', isDatePartOn, 'isTimePartOn:', isTimePartOn);
  console.log('Full section object:', section);
  console.log('section.config:', section.config);  
  console.log('Raw isTimePartOn value:', section.config?.isTimePartOn);
  console.log('Type of isTimePartOn:', typeof section.config?.isTimePartOn);
  

  // Convert string value to dayjs object
  const dayjsValue = value ? dayjs(value) : null;
  
  // Handle value change
  const handleChange = (newValue: Dayjs | null) => {
    if (newValue && newValue.isValid()) {
      onChange(newValue.toISOString());
    } else {
      onChange(null);
    }
  };
  
  // Determine which picker to render
  const renderPicker = () => {
    if (isDatePartOn && isTimePartOn) {
      // Both date and time
      return (
        <DateTimePicker
          label={section.label}
          value={dayjsValue}
          onChange={handleChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error,
              required: !!section.validation?.required
            }
          }}
        />
      );
    } else if (isDatePartOn) {
      // Date only
      return (
        <DatePicker
          label={section.label}
          value={dayjsValue}
          onChange={handleChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error,
              required: !!section.validation?.required
            }
          }}
        />
      );
    } else if (isTimePartOn) {
      // Time only
      return (
        <TimePicker
          label={section.label}
          value={dayjsValue}
          onChange={handleChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error,
              required: !!section.validation?.required
            }
          }}
        />
      );
    } else {
      // Fallback - shouldn't happen but handle gracefully
      return (
        <DatePicker
          label={section.label}
          value={dayjsValue}
          onChange={handleChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error,
              required: !!section.validation?.required
            }
          }}
        />
      );
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ mb: 2 }}>
        {/* Description */}
        {section.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {section.description}
          </Typography>
        )}
        
        {/* Date/Time Picker */}
        {renderPicker()}
      </Box>
    </LocalizationProvider>
  );
};